export default __webpack_public_path__ + "static/media/meter.a7c13278.svg";